import React, { useState } from "react";
import axios from "axios";

/**
 * 회원가입 폼.
 * - 비밀번호 확인은 클라이언트에서 먼저 검증한다.
 * - 아이디 중복/필수값 검증은 서버(front 모듈 /join)가 최종 판단하고,
 *   실패 메시지(예: "이미 사용 중인 아이디입니다")를 그대로 표시한다.
 * - 이름/연락처/이메일은 서버에서 AES-256 암호화되어 DB에 저장된다.
 */
export default function JoinForm({ apiBaseUrl = "", onJoinSuccess, onGoLogin }) {
  const [form, setForm] = useState({
    memberAccount: "",
    memberPassword: "",
    passwordConfirm: "",
    memberName: "",
    phoneNo: "",
    email: "",
  });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (form.memberPassword.length < 8) {
      setError("비밀번호는 8자 이상이어야 합니다.");
      return;
    }
    if (form.memberPassword !== form.passwordConfirm) {
      setError("비밀번호가 일치하지 않습니다.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await axios.post(`${apiBaseUrl}/join`, {
        memberAccount: form.memberAccount.trim(),
        memberPassword: form.memberPassword,
        memberName: form.memberName.trim(),
        phoneNo: form.phoneNo.trim(),
        email: form.email.trim(),
      });
      if (res.data.success) {
        onJoinSuccess();
      } else {
        setError(res.data.message || "회원가입에 실패했습니다.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "회원가입 중 오류가 발생했습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>회원가입</h2>

      <label>아이디</label>
      <input type="text" value={form.memberAccount} onChange={set("memberAccount")} required autoComplete="username" />

      <label>비밀번호 <span className="hint">(8자 이상)</span></label>
      <input type="password" value={form.memberPassword} onChange={set("memberPassword")} required minLength={8} autoComplete="new-password" />

      <label>비밀번호 확인</label>
      <input type="password" value={form.passwordConfirm} onChange={set("passwordConfirm")} required autoComplete="new-password" />

      <label>이름</label>
      <input type="text" value={form.memberName} onChange={set("memberName")} required />

      <label>연락처</label>
      <input type="tel" value={form.phoneNo} onChange={set("phoneNo")} placeholder="010-0000-0000" required />

      <label>이메일</label>
      <input type="email" value={form.email} onChange={set("email")} required />

      {error && <p className="error">{error}</p>}

      <button type="submit" disabled={submitting}>{submitting ? "가입 중..." : "가입하기"}</button>

      <p className="auth-switch">
        이미 계정이 있으신가요? <button type="button" className="link-btn" onClick={onGoLogin}>로그인</button>
      </p>
    </form>
  );
}
